<template>
  <div class="logout-page text-center py-4 px-4 d-flex justify-center">
    <v-progress-circular
      :width="2"
      :size="12"
      color="red"
      indeterminate class="mr-2"></v-progress-circular>
    <p>You're being logged out. Please wait...</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import types from '@/store/types';

export default {
  name: 'logout-page',
  computed: {},
  created() {
    this.logout(this.$router);
  },
  methods: {
    ...mapActions('auth', {
      logout: types.LOGOUT,
    }),
  },
};
</script>
